import { render, staticRenderFns } from "./UtilityTowingCapacity.vue?vue&type=template&id=2f59d473&scoped=true&"
import script from "./UtilityTowingCapacity.vue?vue&type=script&lang=js&"
export * from "./UtilityTowingCapacity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f59d473",
  null
  
)

export default component.exports